export default {
  data () {
    return {
      translate: {
        'system_specification': 'システム仕様',
        'system_function': 'システム機能',
        'usecase': 'ユースケース',
        'communication_design': '通信設計',
        'property': 'プロパティ',
        'attribute': 'アトリビュート'
      },
      childRelations: {
        'system_specification': 'system_function',
        'system_function': 'usecase',
        'usecase': 'communication_design'
      }
    }
  },
  methods: {
    makeToast (title, message, variant = 'default') {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true
      })
    }
  }
}
